import { ca } from '@cian/analytics';

export enum ECommentType {
  General = 'General',
  OffersList = 'OffersList',
  SalePrediction = 'SalePrediction',
}

export function trackCommentAdd(label: ECommentType) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculatorB2BPreview',
    action: 'add_comment',
    label,
  });
}
